/* file description */
import React, { FC, useEffect, useState } from 'react';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';

import { RoleSelectRenderProps } from './type';

export const RadioSelectRender: FC<RoleSelectRenderProps> = ({
  FetchAPI,
  field,
  targerValue,
  setViewValue,
}) => {
  const { dataKey, treeId, prefilter, isFilter, label, value, dataType } = field?.bizConfig || {};
  const [renderData, setRenderData] = useState<any>('');

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  useEffect(() => {
    if (!targerValue) {
      return;
    }
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      filter: isFilter ? (dataType || prefilter) : '',
    };
    getModuleRecordListCache(FetchAPI, treeId, dataKey, params).then((res: any) => {
      const { set = [] } = res || {};
      const listData = set.map((r: any) => convert(r));
      const findDictItem = listData?.find((item: Record<any, any>) => item[value] === targerValue) || {};
      setRenderData(findDictItem[label] || targerValue);
    });
  }, [targerValue]);

  useEffect(() => {
    setViewValue(renderData);
  }, [renderData]);

  return renderData;
};
export default RadioSelectRender;
